import { Product } from '../product/Product'
import { Field, Float, InputType } from 'type-graphql'

@InputType('InventoryAdjustmentInput')
export class InventoryAdjustment {
  @Field(() => Product)
  product: Product

  @Field(() => Float)
  quantity: number
}
